// Section 3.1 - 
export const HOK_RESZVETEL_OPTIONS = {
    hu: [
    { value: 'aktiv_reszvetel', label: 'Aktív részvétel, több tisztségviselő a szakról' },
    { value: 'rendszeres_reszvetel', label: 'Rendszeres részvétel' },
    { value: 'alkalmi_reszvetel', label: 'Alkalmi részvétel' },
    { value: 'min_reszvetel', label: 'Minimális részvétel' },
    { value: 'nincs_reszvetel', label: 'Nincs részvétel' }
    ],
    en: [
    { value: 'aktiv_reszvetel', label: 'Active participation, with several office holders from the programme' },
    { value: 'rendszeres_reszvetel', label: 'Regular participation' },
    { value: 'alkalmi_reszvetel', label: 'Occasional participation' },
    { value: 'min_reszvetel', label: 'Minimal participation' },
    { value: 'nincs_reszvetel', label: 'No participation' }
    ]
};

// Section 3.2 - 
export const SZAKKOLLEGIUM_RESZVETEL_OPTIONS = {
    hu: [
    { value: 'magas_reszvetel', label: 'Magas arányú részvétel (>20% a szak hallgatóiból)' },
    { value: 'kozepes_reszvetel', label: 'Közepes részvétel (10-20%)' },
    { value: 'alacsony_reszvetel', label: 'Alacsony részvétel (<10%)' },
    { value: 'nincs_szakkollegium', label: 'Nincs szakspecifikus szakkollégium' },
    { value: 'nincs_reszvetel', label: 'Nincs részvétel' }
    ],
    en: [
    { value: 'magas_reszvetel', label: 'High level of participation (>20% of programme students)' },
    { value: 'kozepes_reszvetel', label: 'Moderate participation (10–20%)' },
    { value: 'alacsony_reszvetel', label: 'Low participation (<10%)' },
    { value: 'nincs_szakkollegium', label: 'No Talent Management Programme' },
    { value: 'nincs_reszvetel', label: 'No participation' }
    ]
};

// Section 3.3 - 
export const HALLGATOI_CSAPAT_RESZVETEL_OPTIONS = {
    hu: [
    { value: 'tobb_csapat', label: 'Több csapatban is részt vesznek a hallgatók' },
    { value: 'egy_csapat', label: 'Egy csapat működik a szak mellett' },
    { value: 'alkalmi_csapatok', label: 'Alkalmi részvétel csapatokban' },
    { value: 'nincs_reszvetel', label: 'Nincs részvétel' }
    ],
    en: [
    { value: 'tobb_csapat', label: 'Participation in multiple teams' },
    { value: 'egy_csapat', label: 'Operation of one team affiliated with the programme' },
    { value: 'alkalmi_csapatok', label: 'Occasional participation in teams' },
    { value: 'nincs_reszvetel', label: 'No participation' }
    ]
};

// Section 3.4 - 
export const SPORT_RESZVETEL_OPTIONS = {
    hu: [
    { value: 'magas_sport', label: 'Magas részvétel (több hallgató rendszeres sportolása)' },
    { value: 'kozepes_sport', label: 'Közepes részvétel' },
    { value: 'alacsony_sport', label: 'Alacsony részvétel' },
    { value: 'nincs_adat', label: 'Nincs adat' }
    ],
    en: [
    { value: 'magas_sport', label: 'High level of participation (several students engaged in regular sporting activities)' },
    { value: 'kozepes_sport', label: 'Moderate participation' },
    { value: 'alacsony_sport', label: 'Low participation' },
    { value: 'nincs_adat', label: 'No data available' }
    ]
};

// Section 3.4 - 
export const KIEMELKEDO_SPORTEREDMENY_OPTIONS = {
    hu: [
    { value: 'nemzetkozi_helyezesek', label: 'Országos/nemzetközi versenyeken elért helyezések' },
    { value: 'egyetemi_cimek', label: 'Egyetemi bajnoki címek' },
    { value: 'egyeni_eredmeny', label: 'Egyéni kiemelkedő eredmények' },
    { value: 'nincs_eredmeny', label: 'Nincs kiemelkedő eredmény' }
    ],
    en: [
    { value: 'nemzetkozi_helyezesek', label: 'Placements achieved in national/international competitions' },
    { value: 'egyetemi_cimek', label: 'University championship titles' },
    { value: 'egyeni_eredmeny', label: 'Outstanding individual achievements' },
    { value: 'nincs_eredmeny', label: 'No outstanding achievements' }
    ]
};

// Section 3.5 - 
export const OSZTONDIJASOK_SZAMA_OPTIONS = {
    hu: [
    { value: 'jelentosen_novekedett', label: 'Jelentősen növekedett (>20%)' },
    { value: 'novekedett', label: 'Növekedett (10-20%)' },
    { value: 'stabil', label: 'Stabil (±10%)' },
    { value: 'csokkent', label: 'Csökkent (10-20%)' },
    { value: 'jelentosen_csokkent', label: 'Jelentősen csökkent (>20%)' },
    ],
    en: [
    { value: 'jelentosen_novekedett', label: 'Significant increase (>20%)' },
    { value: 'novekedett', label: 'Increase (10-20%)' },
    { value: 'stabil', label: 'Stable (±10%)' },
    { value: 'csokkent', label: 'Decrease (10-20%)' },
    { value: 'jelentosen_csokkent', label: 'Significant decrease (>20%)' },
    ]
};

// Section 3.5 - 
export const OSZTONDIJASOK_ARANYA_OPTIONS = {
    hu: [
    { value: 'magas', label: 'Magas (>15% a szakos hallgatókhoz képest)' },
    { value: 'kozepes', label: 'Közepes (5-15%)' },
    { value: 'alacsony', label: 'Alacsony (<5%)' },
    { value: 'nincs_adat', label: 'Nincs adat' }
    ],
    en: [
    { value: 'magas', label: 'High (>15% relative to students of the programme)' },
    { value: 'kozepes', label: 'Moderate (5-15%)' },
    { value: 'alacsony', label: 'Low (<5%)' },
    { value: 'nincs_adat', label: 'No data available' }
    ]
};